window.SiteReady(($) => {

  console.log('Init Block: Assessment Calculator');

  let Formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  let URLParams = new URLSearchParams(document.location.search);

  function formatMoney(val) {
    return Formatter.format(val);
  }

  function parsePrice(priceString) {
    return parseFloat(priceString.replaceAll(/[^0-9.-]+/g, ''));
  }

  //

  let $items = $('.js-assessment_calculator');

  $items.each((index, el) => {
    let $el = $(el);
    let blockId = $el.attr('id');

    let $communitySelect = $el.find('.js-community_select');
    let $serviceSelect = $el.find('.js-service_select');
    let $rows = $el.find('.js-rows');
    let $careTotal = $el.find('.js-care_total');
    let $placeholder = $el.find('.js-placeholder').clone();
    // let $communityTotal = $el.find('.js-community_total');

    let dataSets = window['CostCalculator' + blockId];

    let sectionTemplate = $el.find('.js-section_template').html();
    let typeTemplate = $el.find('.js-type_template').html();
    let groupTemplate = $el.find('.js-group_template').html();
    let rowTemplate = $el.find('.js-row_template').html();
    let tooltipTemplate = $el.find('.js-tooltip_template').html();

    //

    // let communityTotalParts = ['0', '0'];

    //

    function checkURLParams() {
      let selectedCommunity = URLParams.get('community');
      let selectedService = URLParams.get('service') || 'all';

      $serviceSelect.val(selectedService).trigger('change');

      $communitySelect.val(selectedCommunity).trigger('change');
    }

    //

    function onCommunitySelect(e) {
      let communitySlug = $communitySelect.val();
      let serviceSlug = $serviceSelect.val() || 'all';
      let servicesOptions = {};

      if (typeof dataSets[communitySlug] !== 'undefined') {
        let communityData = dataSets[communitySlug];

        Object.entries(communityData.data).forEach(([key, service]) => {
          if (typeof servicesOptions[ key ] === 'undefined') {
            servicesOptions[ key ] = service.title;
          }
        });
      }

      if (Object.entries(servicesOptions).length == 0) {
        servicesOptions = {
          'all': 'All',
        };
      }

      // Force label
      servicesOptions['all'] = 'Select Care Type';

      let servicesHtml = '';
      let serviceSelected = false;

      Object.entries(servicesOptions).forEach(([key, service]) => {
        let attr = '';

        if (key == 'all' && Object.entries(servicesOptions).length > 1) {
          attr = ' disabled';
        }

        if (serviceSlug == key) {
          attr += ' selected';
          serviceSelected = true;
        }

        servicesHtml += `<option value="${key}"${attr}>${service}</option>`;
      });

      $serviceSelect.html(servicesHtml).show();

      if (!serviceSelected) {
        $serviceSelect.val('all');
      }

      renderCalculator();
    }

    function onServiceSelect(e) {
      renderCalculator();
    }

    function renderCalculator() {
      let communitySlug = $communitySelect.val();
      let serviceSlug = $serviceSelect.val() || 'all';

      if (typeof dataSets[communitySlug] !== 'undefined' && serviceSlug !== 'all') {
        let communityData = dataSets[communitySlug];

        let communityTotal = communityData.total;
        communityTotalParts = communityTotal.split('-');

        let communityServices = communityData.data;

        let html = '';
        let total = 0;
        let index = 0;

        Object.entries(communityServices[serviceSlug].items).forEach(([typeKey, type]) => {
          let sectionHTML = '';

          sectionHTML += typeTemplate.replaceAll('{title}', type.title);

          Object.entries(type.items).forEach(([groupKey, group]) => {
            sectionHTML += groupTemplate.replaceAll('{title}', group.title);

            Object.entries(group.items).forEach(([itemKey, item]) => {
              index++;
              let inputId = blockId + '-input_' + index;
              let label = item.title;
              let price = parseFloat(item.price);
              let cost = formatMoney(price);
              let tooltip = item.tooltip;
              let tooltipHTML = '';

              if (tooltip) {
                tooltipHTML = tooltipTemplate.replaceAll('{index}', index)
                  .replaceAll('{label}', label)
                  .replaceAll('{text}', tooltip);
              }

              sectionHTML += rowTemplate.replaceAll('{cost}', cost)
                .replaceAll('{label}', label)
                .replaceAll('{input}', inputId)
                .replaceAll('{tooltip}', tooltipHTML);

              total += price;
            });
          });

          html += sectionTemplate.replaceAll('{type}', typeKey)
            .replaceAll('{html}', sectionHTML);
        });

        $rows.html(html);

        //$communityTotal.html(communityTotal ? communityTotal : formatMoney( total));

        // let url = window.location.origin + window.location.pathname + '?community=' + communitySlug + '&service=' + serviceSlug;

        // window.history.replaceState({ path: url }, '', url);

        let params = Object.fromEntries(URLParams);

        params.community = communitySlug;
        params.service = serviceSlug;

        window.history.replaceState({}, '', window.location.pathname + '?' + $.param(params));
      } else {
        $rows.html($placeholder);

        window.history.replaceState({}, '', window.location.pathname);
      }

      updateTotals();
    }

    function updateTotals() {
      let total = 0;
      let $checkboxes = $el.find('input[type="checkbox"]');

      $checkboxes.each(function() {
        let $checkbox = $(this);
        let price = parsePrice($checkbox.closest('.calculator_item').find('.calculator_row_price').text());

        if ($checkbox.is(':checked')) {
          total += price;
        }
      });

      $careTotal.text(formatMoney(total));

      // let parsedMin = parsePrice(communityTotalParts[0]);
      // let totalPlusMin = total + parsedMin;
      // let totalMin = formatMoney(totalPlusMin);
      // let totalMinMax = totalMin;

      // if (communityTotalParts.length > 1) {
      //   let parsedMax = parsePrice(communityTotalParts[1]);
      //   let totalPlusMax = total + parsedMax;
      //   let totalMax = formatMoney(totalPlusMax);

      //   totalMinMax += '-' + totalMax;
      // }

      //$communityTotal.html(totalMinMax);
    }

    //

    $communitySelect.on('change', onCommunitySelect);
    $serviceSelect.on('change', onServiceSelect);
    $el.on('change', 'input[type="checkbox"]', updateTotals);

    //

    checkURLParams();

  });

  //

  function closeToolTips() {
    $('.js-assessment_tooltip').removeClass('active');
  }

  function openToolTip(id) {
    closeToolTips();

    $(`.js-assessment_tooltip[data-tooltip-id="${id}"]`).addClass('active');
  }

  $(document).on('click', '.js-assessment_tooltip_trigger', function(e) {
    e.preventDefault();
    e.stopPropagation();

    openToolTip($(e.currentTarget).data('tooltip-id'));
  });

  $(document).on('click', '.js-assessment_tooltip_close', function(e) {
    e.preventDefault();
    e.stopPropagation();

    closeToolTips();
  });

  $(document).on('click', closeToolTips);

});